var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.899,
    height: 23.988,
    viewBox: "0 0 30.899 23.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "orientation-landscape--photos-photo-orientation-landscape-picture-photography-camera-pictures-image",
    transform: "translate(0.377 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.736,24.362h24.6a2.236,2.236,0,0,0,2.236-2.236V4.236A2.236,2.236,0,0,0,27.335,2H2.736A2.236,2.236,0,0,0,.5,4.236v17.89A2.236,2.236,0,0,0,2.736,24.362Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#f79420",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.041,9.291A2.785,2.785,0,1,0,8.257,6.506,2.785,2.785,0,0,0,11.041,9.291Z",
    transform: "translate(9.589 2.128)",
    fill: "none",
    stroke: "#f79420",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.693,19.155A15.872,15.872,0,0,0,3.735,6.216a17,17,0,0,0-3.235.3",
    transform: "translate(0 5.207)",
    fill: "none",
    stroke: "#f79420",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.306,9.436a17.058,17.058,0,0,0-5.467-.9,17.255,17.255,0,0,0-6.845,1.4",
    transform: "translate(9.264 8.085)",
    fill: "none",
    stroke: "#f79420",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIcon);
export default __webpack_public_path__ + "static/media/photo-icon.9fbfb5c391af581a7e956bbc38efa9da.svg";
export { ForwardRef as ReactComponent };